import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

import styled from "styled-components";
import { useTranslation } from "react-i18next";

import * as Icon from "../smartiscity/Icons";
import { getCategoryInfos } from "../utils";

import { useAllContexts } from "../../../hooks/useAllContexts";
import SearchArea from "./SearchArea";
import DataList from "./DataList";

const LeftSidePanel = ({
  data,
  loading,
  selectedItem,
  rightSideBox,
  categoryId,
  selectedCategory,
  handleLeftSide,
  showNewRouteForm,
  refreshComponent,
  refreshMap,
}) => {
  const [showLeftSide, setShowLeftSide] = useState(false);
  const [showSensorsPopover, setShowSensorsPopover] = useState(false);

  const { meteo, sensorTypes, allSensors } = useAllContexts();
  // const { t } = useTranslation();

  const mapData = useMemo(() => getCategoryInfos(categoryId), [categoryId]);

  useEffect(() => {
    const isVisible = !loading;
    handleLeftSide(isVisible);
    setShowLeftSide(isVisible);
  }, [loading, handleLeftSide]);

  return (
    <LeftSideWrapper
      $left={showLeftSide ? "0" : "-396px"}
      $top={
        showLeftSide
          ? categoryId === "122"
            ? "50px"
            : "0"
          : categoryId === "122"
          ? "-340px"
          : "-396px"
      }
    >
      <LeftSideContent>
        <SearchArea
          sensorTypes={sensorTypes}
          showPopover={{ get: showSensorsPopover, set: setShowSensorsPopover }}
          refreshComponent={refreshComponent}
          categoryId={categoryId}
          selectedCategory={selectedCategory}
          refreshMap={refreshMap}
        />

        {!showNewRouteForm.get && (
          <LeftSideHeader $bgColor={mapData?.bgColor}>
            <p>
              {categoryId === "122"
                ? `${selectedCategory === "infra" ? "Υποδομές" : "Διαδρομές"} ${
                    mapData?.mapTitle
                  }`
                : mapData?.mapTitle ?? mapData?.title}
            </p>
          </LeftSideHeader>
        )}

        <DataList
          data={data}
          showNewRouteForm={{ ...showNewRouteForm }}
          mapData={mapData}
          rightSideBox={rightSideBox}
          categoryId={categoryId}
          selectedCategory={selectedCategory}
          selectedItem={selectedItem}
        />
      </LeftSideContent>

      <LeftSideToggleButton
        onClick={() => {
          handleLeftSide(!showLeftSide);
          setShowLeftSide(!showLeftSide);
        }}
      >
        <ToggleArrow
          src={Icon.rightArrow}
          $isLeftSideVisible={showLeftSide}
          alt="Toggle Left Side"
        />
      </LeftSideToggleButton>
    </LeftSideWrapper>
  );
};

export default LeftSidePanel;

// import React, { useState, useEffect, useContext } from "react";
// import * as Icon from "../smartiscity/Icons";
// import {
//   AmeaInfrastructureContext,
//   AmeaRoutesDataContext,
// } from "../../../hooks/context";

// import styled from "styled-components";
// import { getCategoryInfos } from "../utils";

// import "./LeftSidePanel.css";
// import { AmeaCategorySingularName } from "../helpers";
// import Popover from "@material-ui/core/Popover";
// import CloseIcon from "../../../../SMARTCITY/assets/svg/components/CloseIcon";
// import { Button, Select } from "antd";
// import AddCircle from "../../../../SMARTCITY/assets/svg/components/AddCircle";
// import SubMenuPopover from "../../BasicPopover";
// import BasicPopover from "../../BasicPopover";
// import NewRouteForm from "./NewRouteForm";
// import { useTranslation } from "react-i18next";
// import MapFilters from "../container/MapFilters";
// import { useAllContexts } from "../../../hooks/useAllContexts";
// import { useHistory } from "react-router-dom";
// import { useLocation } from "react-router-dom";

// function LeftSidePanel({
//   data,
//   loading,
//   selectedItem,
//   rightSideBox,
//   categoryId,
//   selectedCategory,
//   handleLeftSide,
//   showNewRouteForm,
//   refreshComponent,
//   refreshMap,
// }) {
//   const [showLeftSide, setShowLeftSide] = useState(false);
//   const [showSubsystem, setShowSubsystem] = useState(false);
//   const [newRouteName, setNewRouteName] = useState("");
//   const [newRouteCategory, setNewRouteCategory] = useState("");
//   const [newRouteStartPosition, setNewRouteStartPosition] = useState("");
//   const [newRouteEndPosition, setNewRouteEndPosition] = useState("");
//   const { infrastructureData } = useContext(AmeaInfrastructureContext);
//   const { AmeaRoutesData } = useContext(AmeaRoutesDataContext);
//   const [showSensorsPopover, setShowSensorsPopover] = useState(false);

//   const { meteo, ameaInfrastructures, sensorTypes, allSensors } =
//     useAllContexts();

//   const mapData = getCategoryInfos(categoryId);

//   const { t } = useTranslation();

//   const history = useHistory();
//   const { pathname } = useLocation();

//   useEffect(() => {
//     if (loading) {
//       handleLeftSide(false);
//       setShowLeftSide(false);
//     } else {
//       handleLeftSide(true);
//       setShowLeftSide(true);
//     }
//   }, [data]);

//   const renderMeteoIcons = (items, key) => {
//     return items?.map((item, id) => {
//       return (
//         <img
//           key={`${key}_icon_${id}`}
//           src={`https://alexandria.smartiscity.gr/gallery/vars/Small/${item.sensorvar_icon}`}
//         />
//       );
//     });
//   };

//   const renderData = () => {
//     if (data?.length > 0) {
//       switch (categoryId) {
//         case "5":
//         case "31":
//           return data?.map((item, index) => {
//             return (
//               <LeftSideItemContainer
//                 $selectedItemId={selectedItem.getItem?.mysensor_id ?? null}
//                 $itemId={item.mysensor_id}
//                 style={{ alignItems: "flex-start" }}
//                 key={`${
//                   categoryId === "31" ? "info_box" : "meteo_info"
//                 }_item_${index}`}
//                 onClick={() => {
//                   if (categoryId !== "31") {
//                     if (!rightSideBox.isVisible) {
//                       rightSideBox.setIsVisible(!rightSideBox.isVisible);
//                     }
//                   }
//                   selectedItem.setItem(item);
//                 }}
//               >
//                 <i
//                   className={`im ${
//                     categoryId === "31"
//                       ? "im-icon-Monitor-Vertical"
//                       : "im-icon-Cloud-Sun"
//                   }`}
//                   style={{ fontSize: "30px", float: "left", color: "inherit" }}
//                 ></i>
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "4px",
//                   }}
//                 >
//                   <p style={{ fontWeight: "500" }}>{`${item.mysensor_name}`}</p>
//                   <p style={{ fontSize: "14px" }}>{`${item.sensor_address}`}</p>
//                   <div>
//                     {categoryId === "5" &&
//                       renderMeteoIcons(item.details, item.mysensor_name)}
//                     {categoryId === "31" && item?.metrics && (
//                       <p style={{ fontSize: "14px" }}>
//                         <span style={{ fontWeight: "500", marginRight: "5px" }}>
//                           {item?.metrics[0]?.content}:
//                         </span>
//                         {item?.metrics[0]?.value}
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               </LeftSideItemContainer>
//             );
//           });

//         case "122":
//           return data?.map((item, index) => {
//             return (
//               <LeftSideItemContainer
//                 $selectedItemId={selectedItem?.getItem?.id}
//                 $itemId={item.id}
//                 key={`amea_item_${index}`}
//                 onClick={() => {
//                   if (selectedCategory === "routes") {
//                     if (!rightSideBox.isVisible) {
//                       rightSideBox.setIsVisible(!rightSideBox.isVisible);
//                     }
//                   }
//                   selectedItem.setItem(item);
//                 }}
//               >
//                 <img src={Icon.defaultRoutes} />
//                 {selectedCategory === "infra" ? (
//                   <div>
//                     <p>{`${AmeaCategorySingularName(item.category)} (${
//                       item.title
//                     })`}</p>
//                     <p>{`${item.type}ς Χρήσης`}</p>
//                   </div>
//                 ) : (
//                   <div>
//                     <p>{item.title}</p>
//                     <p style={{ fontSize: "14px" }}>{item.category}</p>
//                     <p style={{ fontSize: "14px" }}>
//                       Απόσταση: {item.distance} m
//                     </p>
//                   </div>
//                 )}
//               </LeftSideItemContainer>
//             );
//           });

//         default:
//           return data?.map((item, id) => {
//             return <p>item {id}</p>;
//           });
//       }
//     } else {
//       return [];
//     }
//   };

//   return (
//     <LeftSideWrapper
//       $left={showLeftSide ? "0" : "-396px"}
//       $top={
//         showLeftSide
//           ? categoryId === "122"
//             ? "50px"
//             : "0"
//           : categoryId === "122"
//           ? "-340px"
//           : "-396px"
//       }
//     >
//       <LeftSideContent>
//         <SearchArea>
//           <SearchWrapper>
//             <InputIcon>
//               <img src={Icon.search} width="20px" />
//             </InputIcon>
//             <SearchInput placeholder="Αναζήτηση" />
//           </SearchWrapper>
//           <DropdownContent>
//             <BasicPopover
//               buttonTitle="Υποσύστημα"
//               showPopover={showSensorsPopover}
//               setShowPopover={setShowSensorsPopover}
//             >
//               <div
//                 style={{
//                   maxHeight: "300px",
//                   padding: "20px",
//                   display: "flex",
//                   flexDirection: "column",
//                   flexWrap: "wrap",
//                   gap: "10px",
//                 }}
//               >
//                 {sensorTypes.SensorTypesData?.map((sensorType) => {
//                   return (
//                     <SensorItem
//                       onClick={() => {
//                         setShowSensorsPopover(false);
//                         history.push(`${pathname}?typeId=${sensorType.id}`);
//                         refreshComponent();
//                       }}
//                     >
//                       {sensorType.title}
//                     </SensorItem>
//                   );
//                 })}
//               </div>
//             </BasicPopover>
//             <BasicPopover buttonTitle="Μεταβλητή">
//               <div
//                 style={{
//                   padding: "20px",
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "20px",
//                 }}
//               >
//                 <p style={{ color: "gray" }}>{t("Επιλέξτε μεταβλήτες")}</p>
//                 <div>
//                   <MapFilters
//                     categoryId={categoryId}
//                     selectedCategory={selectedCategory}
//                     isAmea={categoryId === "122"}
//                     refreshMap={refreshMap}
//                   />
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "row",
//                     gap: "20px",
//                     justifyContent: "flex-end",
//                   }}
//                 >
//                   <Button>Ακύρωση Φίλτρων</Button>
//                 </div>
//               </div>
//             </BasicPopover>
//           </DropdownContent>
//         </SearchArea>

//         {!showNewRouteForm.get && (
//           <LeftSideHeader $bgColor={mapData?.bgColor}>
//             <p>
//               {categoryId === "122"
//                 ? selectedCategory === "infra"
//                   ? `Υποδομές ${mapData?.mapTitle}`
//                   : `Διαδρομές ${mapData?.mapTitle}`
//                 : mapData?.mapTitle ?? mapData?.title}
//             </p>
//           </LeftSideHeader>
//         )}
//         {!showNewRouteForm.get && <LeftSideData>{renderData()}</LeftSideData>}
//         {showNewRouteForm.get && (
//           <LeftSideData>
//             <NewRouteForm
//               showNewRouteForm={showNewRouteForm}
//               mapData={mapData}
//             />
//           </LeftSideData>
//         )}
//       </LeftSideContent>

//       <LeftSideToggleButton
//         onClick={() => {
//           handleLeftSide(!showLeftSide);
//           setShowLeftSide(!showLeftSide);
//         }}
//       >
//         <ToggleArrow src={Icon.rightArrow} $isLeftSideVisible={showLeftSide} />
//       </LeftSideToggleButton>
//     </LeftSideWrapper>
//   );
// }

// export default LeftSidePanel;

const LeftSideWrapper = styled.div`
  position: absolute;
  width: 396px;
  height: calc(100vh - 99px);
  margin-top: 70px;
  background-color: #f5f5f5;
  top: 0;
  left: ${(props) => props.$left};
  z-index: 1;
  transition: left 1s ease, top 1s ease;

  @media only screen and (max-width: 609px) {
    left: unset;
    top: calc(${(props) => props.$top});
    width: 100%;
    height: 400px;
    z-index: 1;
  }

  @media only screen and (min-width: 609px) and (max-width: 908px) {
    top: 55px;
    left: calc(${(props) => props.$left});
  }
`;

const LeftSideToggleButton = styled.div`
  width: 26px;
  height: 52px;
  background-color: #000000e6;
  position: absolute;
  top: 45%;
  right: -26px;
  z-index: 100;
  border-radius: 0 12px 12px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media only screen and (max-width: 609px) {
    width: 52px;
    height: 26px;
    bottom: -26px;
    left: 45%;
    top: unset;
    border-radius: 0 0 12px 12px;
  }
`;

const LeftSideContent = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* Internet Explorer and Edge */
  scrollbar-width: none; /* Firefox */
`;

const LeftSideHeader = styled.div`
  width: 100%;
  height: 90px;
  background-color: ${(props) => props.$bgColor};
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ToggleArrow = styled.img`
  transform: ${(props) =>
    props.$isLeftSideVisible ? "rotate(180deg)" : "unset"};

    @media only screen and (max-width: 609px) {
    transform: ${(props) =>
      props.$isLeftSideVisible ? "rotate(-90deg)" : "rotate(90deg)"};
`;
